var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UserService } from './../../shared/user.service';
import { AngularFireAuth } from '@angular/fire/auth';
import { OnInit } from '@angular/core';
import { auth } from 'firebase/app';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
export class SignupPageComponent {
    constructor(auth, users, router, route) {
        this.auth = auth;
        this.users = users;
        this.router = router;
        this.route = route;
        this.finished = false;
        this.errorMessage = '';
        this.fromEntry = false;
        this.fromVote = false;
    }
    ngOnInit() {
        this.form = new FormGroup({
            email: new FormControl('', [Validators.required, Validators.email]),
            password: new FormControl('', [Validators.required, Validators.minLength(8)]),
        });
        const url = this.route.snapshot.queryParamMap.get('url');
        //console.log("remember url" + url);
        if (url != null) {
            this.backUrl = url;
            if (url.match(/entry/)) {
                console.log('fromEntry!');
                this.fromEntry = true;
            }
            if (url.match(/vote/)) {
                this.fromVote = true;
            }
        }
        else {
            this.backUrl = '';
        }
        //this.backUrl = url ? url : '';
    }
    doSignup() {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('doSignup');
            if (this.form.invalid) {
                Object.keys(this.form.controls).forEach((key) => {
                    this.form.get(key).markAsTouched({ onlySelf: true });
                    console.log(this.form.get(key).errors);
                });
                console.log('invalid');
                return;
            }
            const data = this.form.value;
            const user = this.auth.auth.currentUser;
            try {
                if (user) {
                    if (user.isAnonymous) {
                        const credential = auth.EmailAuthProvider.credential(data['email'], data['password']);
                        yield user.linkAndRetrieveDataWithCredential(credential);
                    }
                    else {
                        console.log(user);
                    }
                }
                else {
                    const newuser = yield this.auth.auth.createUserAndRetrieveDataWithEmailAndPassword(data['email'], data['password']);
                }
                this.navigateNext();
                // this.finished = true;
            }
            catch (e) {
                this.showErrorMessage(e);
            }
        });
    }
    signupWithGoogle() {
        return __awaiter(this, void 0, void 0, function* () {
            const user = this.auth.auth.currentUser;
            try {
                if (user) {
                    if (user.isAnonymous) {
                        yield user.linkWithPopup(new auth.GoogleAuthProvider());
                    }
                }
                else {
                    const newUser = yield this.auth.auth.signInWithPopup(new auth.GoogleAuthProvider());
                    console.log(newUser);
                }
                this.navigateNext();
            }
            catch (e) {
                this.showErrorMessage(e);
            }
        });
    }
    signupWithFacebook() {
        return __awaiter(this, void 0, void 0, function* () {
            const user = this.auth.auth.currentUser;
            try {
                if (user) {
                    if (user.isAnonymous) {
                        yield user.linkWithPopup(new auth.FacebookAuthProvider());
                    }
                }
                else {
                    const newUser = yield this.auth.auth.signInWithRedirect(new auth.FacebookAuthProvider());
                    console.log(newUser);
                }
                this.navigateNext();
            }
            catch (e) {
                this.showErrorMessage(e);
            }
        });
    }
    get email() {
        return this.form.get('email');
    }
    get password() {
        return this.form.get('password');
    }
    navigateNext() {
        return __awaiter(this, void 0, void 0, function* () {
            // KARTEタグ: 新規登録
            tracker.track('signup', {});
            dataLayer.push({
                event: 'signedup',
            });
            const options = { queryParams: { v: 'signedup' } };
            if (yield this.users.getProfile()) {
                this.router.navigate(['/'], options);
            }
            else {
                this.router.navigate(['/profile/step1'], options);
            }
        });
    }
    showErrorMessage(e) {
        console.log(e);
        let errorMessage = '登録に失敗しました';
        if (e.code) {
            switch (e.code) {
                case 'auth/account-exists-with-different-credential':
                    errorMessage = 'メールアドレスが他のアカウントに登録されています';
                    break;
                case 'auth/email-already-in-use':
                    errorMessage = 'メールアドレスが他のアカウントに登録されています';
                    break;
                case 'auth/credential-already-in-use':
                    errorMessage = '既に登録済みです';
                    break;
                default:
                    break;
            }
        }
        this.errorMessage = errorMessage;
    }
}
